'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var UAParser = require('ua-parser-js');
var idx = require('idx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var UAParser__default = /*#__PURE__*/_interopDefaultLegacy(UAParser);
var idx__default = /*#__PURE__*/_interopDefaultLegacy(idx);

var doesNotMatch = function doesNotMatch(_ref) {
  var target = _ref.target,
      parsedTarget = _ref.parsedTarget,
      predicateKey = _ref.predicateKey;
  return Boolean(target && !(idx__default["default"](parsedTarget, function (_) {
    return _[predicateKey].toLowerCase();
  }) || '').includes(target));
};

var Ugent = /*#__PURE__*/function (_Component) {
  _inheritsLoose__default["default"](Ugent, _Component);

  function Ugent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      parsedUserAgent: null,
      shouldRender: false,
      userAgent: null
    });

    return _this;
  }

  var _proto = Ugent.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
        parsedUserAgent = _this$state.parsedUserAgent,
        shouldRender = _this$state.shouldRender,
        userAgent = _this$state.userAgent;

    if (shouldRender) {
      return typeof children === 'function' ? children({
        parsedUserAgent: parsedUserAgent,
        userAgent: userAgent
      }) : children;
    }

    return null;
  };

  return Ugent;
}(React.Component);

_defineProperty__default["default"](Ugent, "defaultProps", {
  browser: null,
  device: null,
  os: null
});

_defineProperty__default["default"](Ugent, "getDerivedStateFromProps", function (props) {
  var userAgent = window.navigator.userAgent;
  var parser = new UAParser__default["default"](userAgent);
  var browser = props.browser,
      device = props.device,
      os = props.os;
  var parsedBrowser = parser.getBrowser();
  var parsedDevice = parser.getDevice();
  var parsedOS = parser.getOS(); // If the parsed device has no type, then we can assume that the device is a computer.

  if (!parsedDevice.type) {
    parsedDevice.type = 'computer';
  } // Figure out if the target user agent attributes match the actual user agent. If they all match, then render.


  var shouldRender = true;

  if (doesNotMatch({
    target: browser,
    parsedTarget: parsedBrowser,
    predicateKey: 'name'
  })) {
    shouldRender = false;
  }

  if (doesNotMatch({
    target: device,
    parsedTarget: parsedDevice,
    predicateKey: 'type'
  })) {
    shouldRender = false;
  }

  if (doesNotMatch({
    target: os,
    parsedTarget: parsedOS,
    predicateKey: 'name'
  })) {
    shouldRender = false;
  }

  var parsedUserAgent = {
    browser: parsedBrowser,
    device: parsedDevice,
    os: parsedOS
  };
  return {
    parsedUserAgent: parsedUserAgent,
    shouldRender: shouldRender,
    userAgent: userAgent
  };
});

exports["default"] = Ugent;
